import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output
} from '@angular/core';
import { FocusElementEnum } from '../_enums/focus-element.enum';

@Directive({
  selector: '[sdUpDown]',
  standalone: true
})
export class SdUpDownDirective {
  constructor(private el: ElementRef) {}

  @Output()
  focusPosition = new EventEmitter<FocusElementEnum>();

  @HostListener('document:keydown.arrowup', ['$event'])
  onKeyUp(e) {
    if (this.el.nativeElement.contains(e.target)) {
      if (e.target.previousElementSibling) {
        e.target.previousElementSibling.focus();
      } else {
        this.focusPosition.emit(FocusElementEnum.first);
        this.el.nativeElement
          ?.querySelector('[tabindex="1"]:last-child')
          ?.focus();
      }
      return;
    }
  }

  @HostListener('document:keydown.enter', ['$event'])
  onEnter(e) {
    if (
      this.el.nativeElement.contains(e.target) &&
      e.target.getElementsByTagName('a').length
    ) {
      e.target.getElementsByTagName('a')[0].click();
    }
  }

  @HostListener('document:keydown.arrowdown', ['$event'])
  onKeyDown(e) {
    if (this.el.nativeElement.contains(e.target)) {
      if (e.target.nextElementSibling) {
        e.target.nextElementSibling.focus();
      } else {
        this.focusPosition.emit(FocusElementEnum.first);
        this.el.nativeElement.querySelector('[tabindex]:first-child')?.focus();
      }
      return;
    }
  }

  @HostListener('document:keydown.shift.tab', ['$event'])
  onTabPrev(e) {
    if (this.el.nativeElement.contains(e.target)) {
      e.preventDefault();
      this.onKeyUp(e);
      return;
    }
  }

  @HostListener('document:keydown.tab', ['$event'])
  onTabNext(e) {
    if (this.el.nativeElement.contains(e.target)) {
      e.preventDefault();
      this.onKeyDown(e);
      return;
    }
  }
}
